import React from 'react';

import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useProgramProfileStore } from 'store/program/useProgramProfileStore';

const Information = () => {
	// Use program's profile store
	const program = useProgramProfileStore(state => state.program);

	return (
		<Container className="p-4 space-y-2">
			<div className="flex space-x-2">
				<Title
					title={program.title}
					className="flex-1 text-xl"
				/>

				<Button
					small
					square
					icon="edit"
					to={`/programs/edit/${program.id}`}
					className="font-normal"
				/>
			</div>
		</Container>
	);
};

export default Information;